import { render, staticRenderFns } from "./modal-feedback-support.vue?vue&type=template&id=f6d7e8b0&scoped=true"
import script from "./modal-feedback-support.vue?vue&type=script&lang=js"
export * from "./modal-feedback-support.vue?vue&type=script&lang=js"
import style0 from "./modal-feedback-support.vue?vue&type=style&index=0&id=f6d7e8b0&prod&scoped=true&lang=css"
import style1 from "./modal-feedback-support.vue?vue&type=style&index=1&id=f6d7e8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d7e8b0",
  null
  
)

export default component.exports